(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quick-order"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var rows = document.querySelectorAll('.quick-order__row');
  var qtyInputs = document.querySelectorAll('.quick-order-qty');
  if (!rows.length || !qtyInputs.length) return;

  var goToCartButton = document.getElementById('quick-order-go-to-cart');
  var clearCartButton = document.getElementById('quick-order-clear-cart');
  var subtotalElement = document.getElementById('quick-order-subtotal');

  // Tracks the most recent quantity update (to avoid race conditions)
  var latestUpdateSeq = 0;

  var CART_BADGE_SELECTOR = '.header__cart-count-bubble';

  // Global discount factor inferred from the cart (e.g. 0.6 for 40% off)
  var globalDiscountFactor = null;

  function updateHeaderCartCount(cart) {
    var count = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
    var elements = document.querySelectorAll(CART_BADGE_SELECTOR);

    elements.forEach(function(el) {
        // Update visible text
        el.textContent = count;

        // Common hide/show behavior; tweak if your theme uses different classes
        if (count === 0) {
        el.classList.add('hidden');
        } else {
        el.classList.remove('hidden');
        }
    });
  }

  // Simple money formatter: $xx.xx
  function formatMoney(cents) {
    cents = parseInt(cents, 10) || 0;
    return '$' + (cents / 100).toFixed(2);
  }

  function updateUIFromCart(cart) {
    updateHeaderCartCount(cart);

    // Subtotal
    if (subtotalElement) {
      var subtotalCents = cart && typeof cart.total_price === 'number' ? cart.total_price : 0;
      subtotalElement.textContent = formatMoney(subtotalCents);
    }

    // Determine global discount factor (if any) from cart line items
    globalDiscountFactor = null;
    if (cart && cart.items) {
      cart.items.forEach(function(item) {
        if (
          typeof item.original_price === 'number' &&
          typeof item.final_price === 'number' &&
          item.original_price > item.final_price
        ) {
          var f = item.final_price / item.original_price;
          if (!globalDiscountFactor || f < globalDiscountFactor) {
            globalDiscountFactor = f;
          }
        }
      });
    }

    // Map items by variant for quick lookup
    var itemsByVariant = {};
    if (cart && cart.items) {
      cart.items.forEach(function(item) {
        itemsByVariant[item.variant_id] = item;
      });
    }

    rows.forEach(function(row) {
      var variantId = parseInt(row.dataset.variantId, 10);
      var qtyInput = row.querySelector('.quick-order-qty');
      var priceCell = row.querySelector('[data-price-cell]');
      var amountCell = row.querySelector('[data-amount-cell]');

      var basePrice = parseInt(priceCell && priceCell.dataset.basePrice, 10) || 0;
      var item = itemsByVariant[variantId];

      var qty = item ? item.quantity : 0;
      var unitPriceCents = basePrice;

      if (item) {
        var finalLinePrice =
          (typeof item.final_line_price === 'number' && item.final_line_price) ||
          (typeof item.line_price === 'number' && item.line_price) ||
          (item.price * item.quantity);

        if (item.quantity > 0) {
          unitPriceCents = Math.round(finalLinePrice / item.quantity);
        }
      } else if (globalDiscountFactor && basePrice > 0) {
        unitPriceCents = Math.round(basePrice * globalDiscountFactor);
      }

      var amountCents = unitPriceCents * qty;

      // Save current unit price for optimistic updates
      if (priceCell) {
        priceCell.dataset.currentPrice = unitPriceCents;
      }

      if (qtyInput) {
        qtyInput.value = qty > 0 ? qty : '';
      }

      if (priceCell) {
        if (unitPriceCents < basePrice && basePrice > 0) {
          priceCell.innerHTML =
            '<span class="quick-order__price-original">' + formatMoney(basePrice) + '</span>' +
            '<span class="quick-order__price-discounted">' + formatMoney(unitPriceCents) + '</span>';
        } else {
          priceCell.innerHTML = formatMoney(unitPriceCents);
        }
      }

      if (amountCell) {
        amountCell.textContent = qty > 0 ? formatMoney(amountCents) : '—';
      }
    });
  }

  function refreshCartUI(seq) {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        if (!seq || seq === latestUpdateSeq) {
          updateUIFromCart(cart);
        }
      })
      .catch(function(error) {
        console.error(error);
      });
  }

  function handleQtyChange(event) {
    var input = event.target;
    var row = input.closest('.quick-order__row');
    if (!row) return;

    var variantId = row.dataset.variantId; // string key
    var max = parseInt(row.dataset.max, 10) || 0;
    var policy = row.dataset.policy;
    var qty = parseInt(input.value, 10) || 0;

    if (qty < 0) qty = 0;

    // Enforce inventory limit when policy = deny
    if (policy !== 'continue' && max > 0 && qty > max) {
      qty = max;
      input.value = max;
    }

    // Optimistic update of Amount using current or base price
    var priceCell = row.querySelector('[data-price-cell]');
    var amountCell = row.querySelector('[data-amount-cell]');
    var unitPriceCents =
      parseInt(priceCell && priceCell.dataset.currentPrice, 10) ||
      parseInt(priceCell && priceCell.dataset.basePrice, 10) ||
      0;

    if (amountCell) {
      amountCell.textContent = qty > 0 ? formatMoney(unitPriceCents * qty) : '—';
    }

    var updates = {};
    updates[variantId] = qty;

    latestUpdateSeq += 1;
    var thisSeq = latestUpdateSeq;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ updates: updates })
    })
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        if (thisSeq === latestUpdateSeq) {
          updateUIFromCart(cart);
        }
      })
      .catch(function(error) {
        console.error(error);
        alert('There was a problem updating your cart. Please try again.');
      });
  }

  // Wire up qty inputs
  qtyInputs.forEach(function(input) {
    input.addEventListener('change', handleQtyChange);
  });

  // Go to cart
  if (goToCartButton) {
    goToCartButton.addEventListener('click', function() {
      window.location.href = '/cart';
    });
  }

  // Clear cart
  if (clearCartButton) {
    clearCartButton.addEventListener('click', function() {
      latestUpdateSeq += 1;
      var thisSeq = latestUpdateSeq;

      fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' }
      })
        .then(function(res) { return res.json(); })
        .then(function(cart) {
          if (thisSeq === latestUpdateSeq) {
            updateUIFromCart(cart);
          }
        })
        .catch(function(error) {
          console.error(error);
        });
    });
  }

  // Initial hydration from existing cart (sets subtotal + discount prices)
  refreshCartUI();
});

  } catch(e) { console.error(e); }
})();
})();
